var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9996 13.5321C9.04715 13.5321 7.45215 11.9463 7.45215 9.98462C7.45215 8.02296 9.04715 6.44629 10.9996 6.44629C12.9521 6.44629 14.5471 8.03212 14.5471 9.99379C14.5471 11.9555 12.9521 13.5321 10.9996 13.5321ZM10.9996 7.82129C9.80798 7.82129 8.82715 8.79296 8.82715 9.99379C8.82715 11.1946 9.79882 12.1663 10.9996 12.1663C12.2005 12.1663 13.1721 11.1946 13.1721 9.99379C13.1721 8.79296 12.1913 7.82129 10.9996 7.82129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9996 21.406C9.64288 21.406 8.27705 20.8926 7.21372 19.8751C4.50955 17.2718 1.52122 13.1193 2.64872 8.17848C3.66622 3.69598 7.58038 1.68848 10.9996 1.68848C10.9996 1.68848 10.9996 1.68848 11.0087 1.68848C14.4279 1.68848 18.3421 3.69598 19.3596 8.18764C20.4779 13.1285 17.4896 17.2718 14.7854 19.8751C13.7221 20.8926 12.3562 21.406 10.9996 21.406ZM10.9996 3.06348C8.33205 3.06348 4.90372 4.48431 3.99622 8.48098C3.00622 12.7985 5.71955 16.5201 8.17622 18.876C9.76205 20.4068 12.2462 20.4068 13.8321 18.876C16.2796 16.5201 18.9929 12.7985 18.0212 8.48098C17.1046 4.48431 13.6671 3.06348 10.9996 3.06348Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location_1.e8f74a1ed56427b76644e3d3d8650cbe.svg";
export { ForwardRef as ReactComponent };